import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-odl-admin',
  templateUrl: './odl-admin.component.html',
  styleUrls: ['./odl-admin.component.scss']
})
export class OdlAdminComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
